import {useQueryClient} from "@tanstack/react-query";
import {useEffect, useRef} from "react";

import {useMe} from "@/src/modules/core/hooks";
import {fetchMe} from "@/src/modules/core/lib/me-query";

import {
  isClientUsingImpersonationBearer,
  isImpersonationActiveFlag,
  setImpersonationActiveFlag,
} from "../lib/impersonation-session";
import {impersonationService} from "../services/impersonation";

export default function useImpersonationRecovery() {
  const queryClient = useQueryClient();
  const {data: me} = useMe();
  const attemptedRef = useRef(false);
  const syncedMeRef = useRef(false);

  useEffect(() => {
    const usingImpersonationBearer = isClientUsingImpersonationBearer();

    // Session bearer is the impersonation token but /me payload is stale (e.g. cached admin).
    if (usingImpersonationBearer) {
      if (me && !me.impersonation?.active && !syncedMeRef.current) {
        syncedMeRef.current = true;
        void fetchMe(queryClient);
      }
      return;
    }

    syncedMeRef.current = false;

    if (
      !usingImpersonationBearer &&
      isImpersonationActiveFlag() &&
      !me?.impersonation?.active
    ) {
      setImpersonationActiveFlag(false);
    }

    if (!me || me.impersonation?.active || attemptedRef.current) return;

    attemptedRef.current = true;

    void impersonationService.recoverImpersonationSession(me).then((sessionChanged) => {
      if (sessionChanged) {
        void fetchMe(queryClient);
      }
    });
  }, [me, queryClient]);
}
